import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import InlineSvg from "../utils/inline-svg";
import { assetIcons } from "../../constants/assets";
import GradientButton from "../utils/gradient-button";
import englishTranslations from "../../i18n/translations/en";
import { darkColors } from "../../theme/colors";
import { useLocation } from "react-router-dom";

export default function NotFoundPageComponent() {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const message = location.state?.message404 || "An unexpected error occurred";

  return (
    <Box
      sx={{
        height: "100vh",
        bgcolor: "black",
        color: "white",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box mt={14}>
          <InlineSvg url={assetIcons.notFoundIcon} />
        </Box>
        <Typography mt={2} fontSize={28} fontFamily={"MontserratBold"}>
          Not Found
        </Typography>
        <Typography mt={2} fontSize={20} fontFamily={"MontserratBold"}>
          Code - 404
        </Typography>

        <Box mt={5}>
          <GradientButton
            text={englishTranslations.back_to_home}
            onClick={() => (window.location.href = "/home")}
            width={isMediumScreen ? 250 : 350}
          />
        </Box>
        <Box
          mt={5}
          borderTop={2}
          borderBottom={2}
          borderColor={darkColors.borderGray}
        >
          <Typography
            width={isMediumScreen ? 300 : 750}
            sx={{
              my: 4,
            }}
          >
            The resource that you are looking for is either moved or doesn’t
            exist
          </Typography>
        </Box>
        <Typography
          variant="body2"
          sx={{
            mt: 4,
            mb: 16,
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
}
